import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { useEditorContext } from '../../Editor/Context';
import { useVisualViewport } from '@wix/da-ds/pkg/hooks/useVisualViewport';
import cn from 'classnames';
import { usePortalNode } from '@wix/da-ds/pkg/popper/hooks/usePortalNode';
import UniversalMobileMenu from '../UniversalMobileMenu';
import s from './FixedMobileMenu.scss';
/**
 * Fixed menu at the top of the screen. Meant to be used with mobile when we don't have a dedicated area to slot
 * the toolbar into.
 */ const FixedMobileMenu = /*#__PURE__*/ React.forwardRef(({ className, noAtomics }, ref)=>{
    const portalNode = usePortalNode('editor-toolbar');
    const editor = useEditorContext();
    const [visualViewport, setVisualViewport] = useState();
    const viewportHandler = useCallback((v)=>{
        setVisualViewport(v);
    }, []);
    useVisualViewport(viewportHandler, true);
    if (!editor) {
        return null;
    }
    var _visualViewport_offsetTop;
    // TODO limit this to the top of editor.view.dom
    const style = {
        top: (_visualViewport_offsetTop = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.offsetTop) !== null && _visualViewport_offsetTop !== void 0 ? _visualViewport_offsetTop : 0,
        width: visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width,
        overflow: 'hidden'
    };
    // We have to use portal to avoid z-index overrides from editor parent elements.
    return portalNode && /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: cn(s['root'], className),
        style: style
    }, /*#__PURE__*/ React.createElement(UniversalMobileMenu, {
        noAtomics: noAtomics,
        omitHRule: true
    })), portalNode);
});
FixedMobileMenu.displayName = 'FixedMobileMenu';
export default FixedMobileMenu;

//# sourceMappingURL=FixedMobileMenu.js.map